import { render } from "./pressure.svg.vue?vue&type=template&id=bcd0dc66"
import script from "./pressure.svg.vue?vue&type=script&lang=js"
export * from "./pressure.svg.vue?vue&type=script&lang=js"
script.render = render

export default script